import { setNewPageViewId } from '../actions/analytics';
import { hasLocationUrlChanged } from './analyticLocationComparator';

const hasPageViewId = (pageView) => Boolean(pageView.id);

const pageViewIdGenerator = (nextState, replace, path, extras) => {
  const nextLocation = nextState.location;

  const { store } = extras;
  const state = store.getState();
  const { pageView = {} } = state.analytics || {};

  if (!hasPageViewId(pageView) || hasLocationUrlChanged(pageView.url, nextLocation)) {
    const nextLocationUrl = `${nextLocation.pathname}${nextLocation.search}`;
    store.dispatch(setNewPageViewId(nextLocationUrl));
  }
  return true;
};

export default pageViewIdGenerator;
